<template>
  <div class="task-list" v-if="isTaskList">
    <template v-if="listType === 0">
      <div class="task-back" :class="{'on-drop-area': isDrop}" @dragover="onDragover" @drop.prevent="onDropTask">
        <p v-if="isDrop">ここにドラッグ＆ドロップすることで予定を作成できます。</p>
      </div>
      <div class="task-left -vertical disp-scroll">
        <div v-if="trelloBoardList.length > 0">
          <p class="-top-8px" v-if="!isTrello" @click="isTrello=true" style="cursor:pointer;">
            <b><span style="font-size:6px;">▶︎</span> trello</b></p>
          <p class="-top-8px" v-else @click="isTrello=false" style="cursor:pointer;">
            <b><span style="font-size:6px;">▼</span> trello</b></p>
          <template v-if="isTrello">
            <template v-for="(board, idx) in trelloBoardList">
              <TrelloBoard 
              :key="idx"
              :trello_board="board"
              :trelloListList="trelloListList"
              :trelloCardList="trelloCardList" 
              @changeEditTaskView="changeEditTaskView"
              @changeDeleteTaskView="changeDeleteTaskView"
              @changeSendTaskView="changeSendTaskView"
              @updateUserTaskLog="updateUserTaskLog"
              @createEvent="createEvent"
              @dragTask="dragTask"
              @dragendTask="dragendTask"
              />
            </template>
          </template>
        </div>
        <p class="-top-8px"><b>最近作成した予定</b></p>
        <template v-if="taskList.length > 0">
          <template v-for="(task, idx) in taskList">
            <TaskCard
              :key="idx + '-tr'"
              :task="task"
              @changeEditTaskView="changeEditTaskView"
              @changeDeleteTaskView="changeDeleteTaskView"
              @changeSendTaskView="changeSendTaskView"
              @updateUserTaskLog="updateUserTaskLog"
              @createEvent="createEvent"
              @dragTask="dragTask"
              @dragendTask="dragendTask"/>
          </template>
        </template>
        <template v-else>
          <img class="no-task-image" src="@/assets/template/task.png">
          <p class="no-task-desc">タスクがありません。<br>行うことを登録してスケジュールに入れていきましょう。</p>
        </template>
      </div>
      <div class="task-left-bottom">
        <div class="task-action">
          <h2 class="-bottom-8px"><b>タスク一覧 / アクション</b></h2>
          <button class="button is-fullwidth -bottom-8px" @click="changeCreateTaskView(true)">タスクを作成する</button>
          <button class="button is-fullwidth -bottom-8px" @click="listType = 1">全画面にする</button>
          <button class="button is-fullwidth -bottom-8px" @click="changeModalTaskLog(true)">送信履歴</button>
          <button class="button is-fullwidth -bottom-8px" @click="changeModalLinkTrello(true)">トレロと連携する</button>          
          <button class="button is-fullwidth -bottom-8px" @click="changeModalTask(false)">閉じる</button>
        </div>
      </div>
      <div class="task-bottom">
        <p class="-top-8px"><b>お気に入りリスト</b></p>
        <div class="bookmark-task disp-scroll" v-if="taskList.length > 0">
          <template v-for="(task, idx) in taskList">
            <TaskCard
              class="bookmark-task-card"
              :key="idx + '-tr'"
              :task="task"
              v-if="task.is_bookmark"
              @changeEditTaskView="changeEditTaskView"
              @changeDeleteTaskView="changeDeleteTaskView"
              @createEvent="createEvent"
              @updateUserTaskLog="updateUserTaskLog"
              @changeSendTaskView="changeSendTaskView"
              @dragTask="dragTask"
              @dragendTask="dragendTask"/>
          </template>
        </div>
        <template v-else>
          <div style="display: flex; align-items: center;">
            <img class="no-task-image" src="@/assets/template/task.png">
            <p class="no-task-desc">タスクがありません。<br>行うことを登録してスケジュールに入れていきましょう。</p>
          </div>
        </template>
      </div>
    </template>
    <template v-if="listType === 1">
      <div class="task-whole disp-scroll">
        <div style="display: flex; flex-wrap: wrap; align-items: center;">
          <h2 class="-left-8px"><b>タスク一覧 / アクション</b></h2>
          <button class="button -left-8px" @click="changeCreateTaskView(true)">タスクを作成する</button>
          <button class="button -left-8px" @click="listType = 0">縮小する</button>
          <button class="button -left-8px" @click="changeModalTaskLog(true)">送信履歴</button>
          <button class="button -left-8px" @click="changeModalLinkTrello(true)">トレロと連携する</button>          
          <button class="button -left-8px" @click="changeModalTask(false)">閉じる</button>
        </div>
        <div style="display: flex; flex-wrap: wrap;">
          <template v-if="trelloBoardList.length > 0">
            <template v-for="(board, idx) in trelloBoardList">
              <TrelloBoard 
              :key="idx"
              :trello_board="board"
              :trelloListList="trelloListList"
              :trelloCardList="trelloCardList" 
              @changeEditTaskView="changeEditTaskView"
              @changeDeleteTaskView="changeDeleteTaskView"
              @changeSendTaskView="changeSendTaskView"
              @updateUserTaskLog="updateUserTaskLog"
              @createEvent="createEvent"
              @dragTask="dragTask"
              @dragendTask="dragendTask"
              />
            </template>
          </template>
          <template v-if="taskList.length > 0">
            <TaskCard
              v-for="(task, idx) in taskList"
              :key="idx + '-tr'"
              :task="task"
              @changeEditTaskView="changeEditTaskView"
              @changeDeleteTaskView="changeDeleteTaskView"
              @createEvent="createEvent"
              @updateUserTaskLog="updateUserTaskLog"
              @changeSendTaskView="changeSendTaskView"
              @dragTask="dragTask"
              @dragendTask="dragendTask"/>
          </template>
          <template v-else>
            <div>
              <img class="no-task-image" src="@/assets/template/task.png">
              <p class="no-task-desc">タスクがありません。<br>行うことを登録してスケジュールに入れていきましょう。</p>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import TaskCard from '@/components/Calendar/organisms/TaskCard'
import TrelloBoard from '@/components/Calendar/organisms/TrelloBoard'
export default {
  components: {
    TaskCard,
    TrelloBoard
  },
  props: {
    isTaskList: {
      type: Boolean,
      required: true
    },
    taskList: {
      type: Array,
      required: true
    },
    trelloBoardList: {
      type: Array,
      required: true
    },
    trelloListList: {
      type: Array,
      required: true
    },
    trelloCardList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      listType: 0,
      isDrop: false,
      draggingTask: null,
      isTrello: false,
    }
  },
  methods: {
    changeEditTaskView (data) {
      this.$emit('changeEditTaskView', data)
    },
    changeDeleteTaskView (data) {
      this.$emit('changeDeleteTaskView', data)
    },
    changeSendTaskView (data) {
      this.$emit('changeSendTaskView', data)
    },
    createEvent (data) {
      this.$emit('createEvent', data)
    },
    changeCreateTaskView (flg) {
      this.$emit('changeCreateTaskView', flg)
    },
    changeModalTask (flg) {
      this.$emit('changeModalTask', flg)
    },
    changeModalTaskLog (flg) {
      this.$emit('changeModalTaskLog', flg)
    },
    changeModalLinkTrello (flg) {
      this.$emit('changeModalLinkTrello', flg)
    },
    updateUserTaskLog (log) {
      this.$emit('updateUserTaskLog', log)
    },
    onDropTask () {
      this.$emit('createEvent', this.draggingTask)
    },
    dragTask (task) {
      this.draggingTask = task
      this.isDrop = true
    },
    dragendTask (task) {
      this.draggingTask = null
      this.isDrop = false
    },
    onDragover (event) {
      event.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
// タスクリスト
.task-list {
  position: absolute;
  width: 100%;
  height: 100%;
  .task-back {
    pointer-events: none;
    position: absolute;
    left: 248px;
    height: calc(100% - 248px);
    width: calc(100% - 248px);
    z-index: 20001;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s;
    p {
      font-size: 28px;
      font-weight: 600;
    }
  }
  .on-drop-area {
    pointer-events: auto;
    border: dashed 4px #922;
    background: rgba(255, 255, 255, 0.3);
  }
  .task-whole {
    position: absolute;
    height: 100%;
    width: 100%;
    background: #FEFEFE;
    z-index: 20001;
    padding: 24px;
    margin-top: 2px;
  }
  .task-left {
    position: absolute;
    left: 0;
    height: calc(100% - 296px);
    width: 248px;
    background: #FFF0F5;
    z-index: 20002;
    padding: 6px 8px 8px 8px;
    margin-top: 2px;
  }
  .task-left-bottom {
    position: absolute;
    background: #FFF0F5;
    bottom: 0;
    left: 0;
    width: 248px;
    height: 296px;
    z-index: 20003;

    .task-action {
      width: 100%;
      height: 100%;
      background: #FEFEFE;
      padding: 16px;
      border: solid thin #ccc;
      border-radius: 16px;
    }
  }
  .task-bottom {
    text-align: left;
    position: absolute;
    bottom: 0;
    right: 0;
    width: calc(100% - 248px);
    height: 248px;
    background: #FEFEFE;
    z-index: 20002;
    padding: 8px;
  }
  .-horizontal {
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    text-align: left;
  }
  .bookmark-task {
    width: 100%;
    height: calc(100% - 25px);;
    display: flex;
    justify-content: left;
    position: relative;
    flex-wrap: wrap;
    // 要素左寄せ
    .bookmark-task-card {
      height: 150px;
      // vertical-align: top;
      // height: auto;
      // padding: 8px;
    }
  }
}
.no-task-image {
  width: 200px;
  object-fit: cover;
}
.no-task-desc {
  color: #666;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Calendar/organisms/IslandTask.vue